import { apiBaseUrl } from './api';
import { applyRuntimeVideoCdnUrl, getVideoCdnBaseUrl } from './listingMedia';

/**
 * Ensure the client can resolve listing video keys → CDN URLs.
 * No-op when CRA already baked REACT_APP_VIDEO_CDN_URL or SSR injected it.
 * Otherwise fetches from the API server (same .env as upload/transcode).
 *
 * @returns {Promise<string>} resolved CDN base, or ''
 */
export const hydrateVideoCdnUrl = async () => {
  const existing = getVideoCdnBaseUrl();
  if (existing) {
    return existing;
  }

  try {
    const response = await globalThis.fetch(`${apiBaseUrl()}/api/video-cdn-config`, {
      credentials: 'same-origin',
    });
    if (!response.ok) {
      return '';
    }
    const data = await response.json().catch(() => null);
    applyRuntimeVideoCdnUrl(data?.videoCdnUrl);
    return getVideoCdnBaseUrl();
  } catch (e) {
    return '';
  }
};
